/**
 * Константы для работы с датами
 */

/**
 * Названия месяцев в родительном падеже
 */
export const monthNames = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
]

/**
 * Стандартные значения для начального периода
 */
export const DEFAULT_START_PERIOD = {
  YEAR: 2024,
  MONTH: 0, // Январь
  DAY: 1,
}
